import { Typography } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  ListResponseOfState,
} from "services/KnowfullyAdminClient";
import { MetaValuePreviewProps } from "pages/AttributesPage/CustomAttributeComponents/metaValueComponents";

export function StateDropdownPreview({
  metaValueName,
  attributeMetaValues,
}: MetaValuePreviewProps) {
  const { stateService } = useGlobalContext();

  const storedId = attributeMetaValues?.find(
    (m) => m.name === metaValueName,
  )?.value;

  const { data } = useQuery<ListResponseOfState>(
    ["stateService.getStates"],
    () =>
      stateService.getStates(
        ListRequestOfBaseFilter.fromJS({ sortField: "stateName" }),
      ),
  );

  if (!storedId) return null;

  const state = data?.data?.find(
    (d) => String(d.id ?? "").toLowerCase() === String(storedId).toLowerCase(),
  );
  const label = state
    ? state.name
      ? `${state.stateName} (${state.name})`
      : state.stateName ?? storedId
    : storedId;

  return <Typography variant="body2">{label}</Typography>;
}
